@if (steps.length) {
  <ul class="steps">
    <!--Descrição para screen readers-->
    <p class="s-is-hidden">Etapas do pagamento</p>
    @if (step$ | async; as current) {
      <span class="steps__bar" aria-hidden="true">
        <span
          class="steps__bar-inner"
          [ngStyle]="{ width: ((current - 1) / (steps.length - 1)) * 100 + '%' }"
        >
        </span>
      </span>
      @for (step of steps; track step; let index = $index) {
        <li
          class="steps__item"
          [ngClass]="{ '--is-completed': index + 1 <= current, '--current': index + 1 === current }"
        >
          {{ step }}
          <!--Descrição para screen readers-->
          <p class="s-is-hidden">
            {{ index + 1 | statusByStep: current }}
          </p>
        </li>
      }
    }
  </ul>
}
